import { useEffect, useState, useContext } from "react"
import { Link } from "react-router-dom"
import { BiSolidPrinter } from "react-icons/bi"
import api from "../../api"
import { Pagination } from "../../components"
import { useSchools } from "../../components/utils"

import styles from './style.module.css'

const ConferenceUsers = () => {
    const [user, setUser] = useState(null)
    const { value: tagsValue, handleChange: handleTagsChange, setValue: setTagsValue } = useSchools()
    const [peoplePage, setPeoplePage] = useState(1)
    const [peopleList, setPeopleList] = useState()
    const [peopleCount, setPeopleCount] = useState(0)

    const getUser = () => {
        api.getUserData()
            .then(res => {
                setUser(res)
            })
    }
    useEffect(_ => {
        getUser()
    }, [])

    const getNews = ({ page = 1, tags }) => {
        api.getRegistrationUsers({ page, tags })
            .then(res => {
                const { count } = res
                setPeopleList(res)
                setPeopleCount(count)
            })
    }

    useEffect(_ => {
        getNews({ page: peoplePage, tags: tagsValue })
    }, [peoplePage, tagsValue])


    useEffect(_ => {
        api.getConferences()
            .then(tags => {
                setTagsValue(tags.results.map((conference) => (conference.conference_school?.map((tag) => ({ ...tag, value: true })))))
            })
    }, []);

    return (
        <>
            <table>
                <thead>
                    <tr>
                        <th>ФИО</th>
                        <th>Регион</th>
                        <th>Учреждение</th>
                        <th>Должность</th>
                        <th>Телефон</th>
                        <th>Email</th>
                        <th>Печать</th>
                    </tr>
                </thead>
                {peopleList.results.map((people) => {
                    return (
                        <tbody>
                            <tr>
                                <td>{people.fio}</td>
                                <td>{people.region}</td>
                                <td>{people.job_place}</td>
                                <td>{people.job}</td>
                                <td>{people.phone}</td>
                                <td>{people.email}</td>
                                <td className={styles.print}>
                                    <Link
                                        to={`/api/registration/${people.id}/generate_file`}
                                        target="_blank"
                                    >
                                        <BiSolidPrinter />
                                    </Link>
                                </td>

                            </tr>
                        </tbody>
                    )
                })}
            </table>
            <Pagination
                count={peopleCount / 1020}
                limit={1}
                page={peoplePage}
                onPageChange={page => setPeoplePage(page)}
            />
        </>
    );
}

export default ConferenceUsers;